import type { CommonService } from '../components/common/common.service'
import type { RestangularService } from '../components/common/restangular.service'
import type { GroupService } from '../group/group.service'

import { app } from '../app.module'

interface IParams {
  type: string
  id: string
  snsType: string
  groupId: string
}

/**
 * ホーム画面表示用のコンポネント
 * @class Home
 */
class Home {
  constructor(
    private $rootScope,
    private $location,
    private $mdDialog,
    private RestangularService: RestangularService,
    private CommonService: CommonService,
    private GroupService: GroupService
  ) {
    this.init()
  }

  /**
   * 初期化
   */
  private init(): void {
    // URLのパラメータを取得してセット
    const urlParams: IParams = this.$location.search()

    // パラメータがない場合、リターン
    if (urlParams.type === undefined) {
      return
    }

    const endpoint = 'common/decipher'

    // グループIDを復号化
    this.RestangularService.request('GET', endpoint, {
      cipher_id: urlParams.groupId,
    }).then((decipheredGroupId) => {
      const memoGroupId = decipheredGroupId[0].data

      // グループIDが違う場合、切り替える
      if (Number(memoGroupId) !== Number(this.$rootScope.groupId)) {
        this.GroupService.changeGroup(memoGroupId, false)
      } else {
        // 同じグループの場合、アクティビティ対象モーダルを開く
        this.showModalFromMail(urlParams)
      }
    })
  }

  /**
   * メール経由のモーダル表示
   */
  private showModalFromMail(urlParams: IParams): void {
    const endpoint = 'common/decipher'

    // アクティビティ対象IDを復号化
    this.RestangularService.request('GET', endpoint, {
      cipher_id: urlParams.id,
    }).then((decipheredObjectId) => {
      const memoObectId = decipheredObjectId[0].data

      switch (urlParams.type) {
        case 'postMemo':
          // メモの投稿モーダルを開く
          this.$mdDialog.show({
            template: `<memo-management-modal object-type="post" object-id=${memoObectId} sns-type=${urlParams.snsType}></memo-management-modal>`,
            clickOutsideToClose: true,
          })
          break

        case 'accountMemo':
          // アカウント詳細モーダルを開く
          this.CommonService.showAccountDetailModal(urlParams.snsType, 'memo', memoObectId)
          break
      }
    })
  }
}

app.component('home', {
  template: require('./home.pug')(),
  controller: Home,
})
